<div class="ui-g ui-fluid">
  <div class="ui-g-6" *ngIf="showParentSelectionField && !isParent">

    <h3>{{ 'customerInfoSheet.familyCardTitle' | translate }}</h3>

    <p-autoComplete
    [(ngModel)]="parent"
    [suggestions]="availableParents"
    (completeMethod)="getFilteredAvailableParents($event)"
    field="label"
    placeholder="{{ 'customerInfoSheet.searchAvailableParentPlaceholder' | translate }}">
    </p-autoComplete>

    <p class="input-error-notification" style="margin-top: 10px; margin-bottom: 0;" *ngIf="invalidParent">
      {{ 'customerInfoSheet.invalidParentMsg' | translate }}
    </p>

    <button
    pButton
    type="button"
    class="k-generic-btn"
    style="margin-top: 10px;"
    label="{{ 'customerInfoSheet.link' | translate }}"
    (click)="linkCustomerToParent()"
    [disabled]="!parent">
    </button>
  </div>

  <div class="ui-g-6" *ngIf="linkedCustomers">
    <h3 *ngIf="isParent">{{ 'customerInfoSheet.sons' | translate }}</h3>
    <h3 *ngIf="!isParent && linkedCustomers?.length > 0">{{ 'customerInfoSheet.parent' | translate }}</h3>
    <ul>
      <li *ngFor="let customer of linkedCustomers" style="margin-bottom: 7px;">
        <a [routerLink]="['/customers-details', customer.customerHostId]">{{ customer.name }} {{ customer.surname }}</a>
      </li>
    </ul>
  </div>

</div>




// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/family-card/family-card.component.html